import type { Glyph } from "./types";

export const ErrorIcon: Glyph = (props) => (
  <svg viewBox="0 0 16 16" aria-hidden="true" fill="currentColor" {...props}>
    <circle cx="8" cy="8" r="7.5" fill="none" stroke="currentColor" />
    <path d="M14 8C14 11.314 11.314 14 8 14C4.686 14 2 11.314 2 8C2 4.686 4.686 2 8 2C11.314 2 14 4.686 14 8ZM8 5C7.598 5 7.285 5.347 7.325 5.746L7.588 8.377C7.609 8.589 7.787 8.75 8 8.75C8.213 8.75 8.391 8.589 8.412 8.377L8.675 5.746C8.715 5.347 8.402 5 8 5ZM8.001 9.5C7.587 9.5 7.251 9.836 7.251 10.25C7.251 10.664 7.587 11 8.001 11C8.415 11 8.751 10.664 8.751 10.25C8.751 9.836 8.415 9.5 8.001 9.5Z" />
  </svg>
);

export default ErrorIcon;
